kendo.data.binders.widget.reference = kendo.data.Binder.extend({

    _returnElement: function() {
        return this.element;
    },

    init: function(element, bindings, options) {
        kendo.data.Binder.fn.init.call(this, element, bindings, options);
        bindings["reference"].set($.proxy(this._returnElement, this));
    },

    refresh: function() {}
});

kendo.data.binders.reference = kendo.data.binders.widget.reference.extend({
    _returnElement: function() {
        return $(this.element);
    }
})